<div class="form-horizontal">

    <edit-prop label="Study Group" prop="sAGID" szs="2,7">
        <select *ngIf="_FSAGs" class="form-control" [ngModel]="entity.sAGID" (change)="entity.sAGID=$any($event.target).value">
            <option selected value>-- None --</option>
            <option *ngFor="let fsag of _FSAGs" [value]="fsag.sAGID">{{fsag.note}}</option>
        </select>
    </edit-prop>

</div>